import { AfterViewInit, Component, HostListener, Input, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { UiHelper } from '@helpers/ui.helper';
// for material slide component etc.

import { LocalizationService } from '@services/localization.service';

@Component({
  selector: 'navbar-title-component',
  templateUrl: '../sharedTemplates/navbar.title.component.html',
})
export class NavbarTitleComponent {
  @Input() titleTranslate = '';
  @Input() title = '';

  constructor(private _UiHelper: UiHelper, public _LZ: LocalizationService, private _Location: Location) {}

  backButton() {
    this._Location.back();
  }
}
